
































import { defineComponent, toRefs, PropType, computed, watch, nextTick } from '@vue/composition-api';
import {
  useCreativeFormItemPrecheck,
  useCreativeIs,
  useStdObjectiveType,
  useCreativeTextValidate,
} from '@tt4b/ttam-hooks';
import {
  AcoFormData,
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  NormalCreative,
  PrecheckResult,
  SmartTextSource,
} from '@tt4b/ttam-enums';
import AdText from './index';
import { useTitleSuggestion } from './../../common/creative-title-suggestion/use-title-suggestion';

const name = 'ttam-ad-text-lite-compose';
const spaceEnum = ' ';
export default defineComponent({
  name,
  components: {
    TtamAdTextLite: AdText.TtamAdTextLite,
    TtamAdTextLabel: AdText.TtamAdTextLabel,
  },
  props: {
    tips: {
      type: String,
      required: false,
    },
    titleI18n: {
      type: String,
      required: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    rejectReason: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    precheckResult: {
      type: Object as PropType<PrecheckResult>,
      default: () => ({
        materialResults: [],
        summaryResults: [],
      }),
    },
    activeCreativeIndex: {
      type: Number,
      default: 0,
    },
    createMode: {
      type: String,
      default: 'create',
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    adTextValidator: {
      type: Function,
      required: true,
    },
    isValidateFailed: {
      type: Boolean,
    },
    autosize: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const {
      isValidateFailed,
      adgroupData,
      campaignData,
      creativeData,
      isDisabledCreative,
      createMode,
      normalCreativeData,
      adTextValidator,
    } = toRefs(props);
    const { isNative, isSupportSmartText, isSupportSmartTranslation, isPullTTPostNativeAd, isTTBAPushVideoNativeAd } =
      useCreativeIs({
        campaignFormData: campaignData,
        adgroupFormData: adgroupData,
        normalCreativeData,
        createMode,
      });
    const { isChecking, computedTitleSuggestionList, checkTitle, computedTypoModel, clearTypoModel } =
      AdText.useCheckTitle({ adgroupData, creativeData, emit });
    const { isProductSales } = useStdObjectiveType({ campaignFormData: campaignData });
    const { refTitle } = AdText.useTitleValidateStatus();
    const { inputNode } = AdText.useInputNodeFocus();
    const { textareaDisabled } = AdText.useTextareaPropsDisabled({
      isDisabledCreative,
      isPullTTPostNativeAd,
      isTTBAPushVideoNativeAd,
    });
    const { handleOpenSmartText, handleOpenSmartTranslation } = AdText.useCreativeSmartDrawerHandler();
    const { triggerText } = AdText.useTrackTitleEvent({ adgroupData, creativeData });

    const _title = computed({
      get: () => creativeData.value.title || '',
      set: val => {
        emit('change', val);
      },
    });

    const clearValidate = (data: string) => {
      refTitle.value.clearValidate();
    };
    const handleClearValidate = () => {
      clearValidate('title');
    };
    // NOTE:从素材库选择原生视频，回填了title后需要清空校验提示，blur无法监听到，因此只能用watch
    watch(
      () => _title.value,
      () => {
        nextTick(() => {
          if (isPullTTPostNativeAd.value) {
            clearValidate('title');
          }
        });
      },
      { immediate: true },
    );

    const { isDisabledPrecheckAlert } = useCreativeFormItemPrecheck();

    let debounceFun = null;
    const {
      debounceGetTitleSuggestion,
      hide: hideTitleSuggestion,
      immediateDebounceGetTitleSuggestion,
    } = useTitleSuggestion({ adgroupData, campaignData, creativeData });
    const checkTitleSuggestion = () => {
      if (_title.value.slice(-1) === spaceEnum) {
        immediateDebounceGetTitleSuggestion(_title.value);
        debounceFun && debounceFun.cancel();
      } else {
        debounceFun = debounceGetTitleSuggestion;
        debounceGetTitleSuggestion(_title.value);
      }
    };
    const handleTitleBlur = () => {
      if (!_title.value) {
        return;
      }
      checkTitle();
      triggerText();
      nextTick(() => {
        hideTitleSuggestion(true);
      });
    };

    const checkDisabled = computed(() => isDisabledPrecheckAlert.value || !_title.value);

    const onCreativeDataChange = data => {
      emit('creativeData-change', data);
    };
    const validator = {
      title: [{ validator: adTextValidator.value, trigger: 'blur' }],
    };
    return {
      validator,
      name,
      refTitle,
      inputNode,
      _title,
      checkDisabled,
      textareaDisabled,
      MAX_TITLE_LENGTH: AdText.MAX_TITLE_LENGTH,
      isSupportSmartText,
      isSupportSmartTranslation,
      isDisabledPrecheckAlert,
      isChecking,
      computedTitleSuggestionList,
      computedTypoModel,
      SmartTextSource,
      isProductSales,
      checkTitle,
      clearTypoModel,
      handleTitleBlur,
      checkTitleSuggestion,
      handleClearValidate,
      handleOpenSmartText,
      handleOpenSmartTranslation,
      onCreativeDataChange,
    };
  },
});
